define('views/components/manual_payment/manual_payment_list',['require','views/base/list_view','views/components/manual_payment/manual_payment','text!templates/components/manual_payment/manual_payment_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/manual_payment/manual_payment');

    var temp = require("text!templates/components/manual_payment/manual_payment_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

